import Flickity from 'flickity';

export default class CustomerStoryVideos {
  constructor() {
    const $els = document.querySelectorAll('.js-customer-story-videos');
    $els.forEach($el => new Carousel($el));
  }
}

class Carousel {
  constructor($el) {
    this.$el = $el;
    this.activeClass = 'is-active';
    this.$tabs = this.$el.querySelectorAll('.js-customer-story-videos-tab');
    this.$carousel = this.$el.querySelector('.js-customer-story-videos-carousel');
    this.$nextBtn = this.$el.querySelector('.js-customer-story-videos-carousel-next-btn');
    this.$prevBtn = this.$el.querySelector('.js-customer-story-videos-carousel-prev-btn');
    this.$iframes = this.$el.querySelectorAll('iframe');

    this.flickity = new Flickity(this.$carousel, {
      imagesLoaded: true,
      prevNextButtons: false,
      pageDots: false,
      percentPosition: false,
      wrapAround: true,
    });

    this.flickity.on('select', this.onSelect.bind(this));

    this.$nextBtn?.addEventListener('click', this.next.bind(this));
    this.$prevBtn?.addEventListener('click', this.prev.bind(this));

    this.$tabs.forEach(($tab, index) => {
      $tab.addEventListener('click', this.goToSlide.bind(this, $tab, index));
    });
  }

  stopVideos() {
    this.$iframes.forEach(($iframe) => {
      $iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
    })
  }

  /**
   * @function next
   * @param {Event} e
   * @returns void
   * Goes to next slide in carousel
   */
  next(e) {
    if (!this.flickity) return;

    e.preventDefault();
    this.flickity.next();
  }

  /**
   * @function prev
   * @param {Event} e
   * @returns void
   * Goes to previous slide in carousel
   */
  prev(e) {
    if (!this.flickity) return;

    e.preventDefault();
    this.flickity.previous();
  }

  /**
   * @function goToSlide
   * @param {HTMLButtonElement} $tab tab that has been clicked
   * @param {Number} index slide index
   * @returns void
   * Goes to specific slide in carousel based on index
   */
  goToSlide($tab, index = 0) {
    if (!this.flickity || !$tab) return;

    this.$tabs.forEach($tab => $tab.classList.remove(this.activeClass));
    $tab.classList.add(this.activeClass);

    this.flickity.select(index);
  }

  /**
   * @function onSelect
   * @param {Number} index
   * Fired when the Flickity slide changes
   */
  onSelect(index) {
    this.stopVideos();
    this.$tabs.forEach($tab => $tab.classList.remove(this.activeClass));
    this.$tabs[index]?.classList.add(this.activeClass);
  }
}
